import React, { useCallback } from 'react';

import useForwardedRef from '@ast/magma/utils/useForwardedRef';

export const useScrollIntoView = <T extends HTMLElement>(scrollParams: boolean | ScrollIntoViewOptions = true, externalRef?: React.Ref<T>) => {
  const scrollRef = useForwardedRef(externalRef || null);

  const scrollIntoView = useCallback(() => {
    if (scrollRef.current) {
      scrollRef.current?.scrollIntoView(scrollParams);
    }
  }, []);

  return { scrollRef, scrollIntoView };
};
